export default ({ to, from, next }) => {
    if (localStorage.getItem('userToken')) {
        next('/gates')
        
        return false;
    }

    next()
}